import React from "react";
import { ContentPage } from "@/components/ContentPage";

const sections = [
  {
    id: "cancellation",
    heading: "Cancellation window",
    body: (
      <>
        <p>
          You can cancel any booking directly from your dashboard. Refunds are
          calculated basis how close to the ride start time the cancellation is
          made.
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li><span className="font-semibold text-ink">More than 24 hours before start</span> — full refund of paid amount.</li>
          <li><span className="font-semibold text-ink">Between 24 and 6 hours before start</span> — 75% refund; a service fee is retained.</li>
          <li><span className="font-semibold text-ink">Less than 6 hours before start</span> — 50% refund.</li>
          <li><span className="font-semibold text-ink">No-show at delivery</span> — no refund; the booking is treated as consumed.</li>
        </ul>
      </>
    ),
  },
  {
    id: "refund-timing",
    heading: "Refund timing",
    body: (
      <p>
        Refunds are initiated within 24 business hours of cancellation. Once
        initiated, banks typically credit the amount back to the original
        payment method within 5–7 working days.
      </p>
    ),
  },
  {
    id: "modifications",
    heading: "Modifications",
    body: (
      <p>
        Modifying the dates, pickup city or plan is free before the booking
        starts, subject to vehicle availability. Any price difference is
        settled through a top-up or a partial refund.
      </p>
    ),
  },
  {
    id: "operator-cancellation",
    heading: "Cancellations by eBikeGo",
    body: (
      <p>
        In rare cases where we cannot fulfil a booking (vehicle downtime,
        force-majeure), we cancel and refund the full amount, plus a service
        credit toward your next ride as an apology.
      </p>
    ),
  },
];

const RefundPolicy = () => (
  <ContentPage
    testId="refund-policy-page"
    eyebrow="Cancellation & Refund"
    title="Change of plans? We'll make it easy."
    subtitle="Cancel or modify from your dashboard. Here's how refunds work at each cancellation window."
    sections={sections}
  />
);

export default RefundPolicy;
